module.exports = __webpack_public_path__ + "site/img/31.74e6c94d.jpg";